module.exports = __webpack_public_path__ + "static/media/gemWrite.002342a9.png";